export default __webpack_public_path__ + "static/media/Santiago_Innova.98648f4b.png";